import React from 'react';

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

function Image(props: ImageProps) {
  return <img {...props} />;
}

export default Image;
